import { Star, Quote } from "lucide-react";
import type { ReviewConfig } from "@/lib/site-config";

export function ReviewCard({ review, featured }: { review: ReviewConfig; featured?: boolean }) {
  return (
    <figure
      className={`relative flex flex-col rounded-2xl surface-premium surface-premium-hover overflow-hidden ${
        featured ? "p-7 md:p-8 border-primary/25" : "p-6"
      }`}
    >
      {featured && (
        <span className="absolute right-5 top-5 inline-flex items-center rounded-full bg-primary/10 border border-primary/20 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.18em] text-primary">
          Featured
        </span>
      )}

      <Quote className="h-7 w-7 text-primary/15 shrink-0" strokeWidth={2.5} />

      <div className="mt-3 flex items-center gap-3">
        <div className="flex gap-0.5">
          {Array.from({ length: review.rating }).map((_, i) => (
            <Star key={i} className="h-3.5 w-3.5 fill-[#FBBC04] text-[#FBBC04]" />
          ))}
        </div>
        <span className="text-[10px] font-bold text-muted-foreground/80 uppercase tracking-[0.18em]">
          {review.service}
        </span>
      </div>

      <blockquote
        className={`mt-3 text-foreground/80 leading-relaxed flex-1 ${featured ? "text-[15px]" : "text-[13.5px]"}`}
      >
        {review.text}
      </blockquote>

      <figcaption className="mt-5 pt-4 border-t border-border/60 flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-bold">
          {review.name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-foreground tracking-tight">{review.name}</div>
          {review.sourceUrl ? (
            <a
              href={review.sourceUrl}
              target="_blank"
              rel="noreferrer noopener"
              className="text-[10px] font-semibold uppercase tracking-[0.16em] text-primary hover:underline"
            >
              From our {review.source || "Google"} reviews ↗
            </a>
          ) : (
            <div className="text-[10px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
              From our {review.source || "Google"} reviews
            </div>
          )}
        </div>
      </figcaption>
    </figure>
  );
}
